import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import FooterSection from './components/FooterSection';
import CursorTrail from './components/CursorTrail';
import Home from './pages/Home';
import ComoFunciona from './pages/ComoFunciona';
import Precios from './pages/Precios';
import KompaClub from './pages/KompaClub';
import FAQ from './pages/FAQ';

function App() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Router>
      <div className="App overflow-x-hidden">
        <CursorTrail />
        <Header scrollToSection={scrollToSection} />
        <Routes>
          <Route path="/" element={<Home scrollToSection={scrollToSection} />} />
          <Route path="/como-funciona" element={<ComoFunciona scrollToSection={scrollToSection} />} />
          <Route path="/precios" element={<Precios />} />
          <Route path="/kompa-club" element={<KompaClub />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
        <FooterSection scrollToSection={scrollToSection} />
      </div>
    </Router>
  );
}

export default App;
